import { render } from "./Child.vue?vue&type=template&id=c0fe293a"
import script from "./Child.vue?vue&type=script&lang=ts"
export * from "./Child.vue?vue&type=script&lang=ts"
script.render = render

export default script